const analyticsEventNames = {
  KBB_ANALYTICS_EVENT: 'kbbAnalyticsEvent',
  CS_ANALYTICS_EVENT: 'csAnalyticsEvent'
};
const isValidEventDataString = function (eventDataString) {
  return typeof eventDataString === 'string' && (eventDataString.indexOf(analyticsEventNames.KBB_ANALYTICS_EVENT) > -1 || eventDataString.indexOf(analyticsEventNames.CS_ANALYTICS_EVENT) > -1);
};
const isValidEvent = function (eventData) {
  return eventData && typeof eventData === 'object' && (eventData.type === analyticsEventNames.CS_ANALYTICS_EVENT || eventData.type === analyticsEventNames.KBB_ANALYTICS_EVENT) && eventData.event;
};
export const getAnalyticsMessage = function (event) {
  const {
    data: eventData
  } = event || {};
  if (!eventData) {
    return null;
  }
  let eventObj = null;
  if (isValidEventDataString(eventData)) {
    try {
      eventObj = JSON.parse(eventData);
    } catch (err) {
      console.error(err);
    }
  } else if (typeof eventData === 'object') {
    eventObj = eventData;
  }
  if (eventObj && isValidEvent(eventObj)) {
    return eventObj.event;
  }
  return null;
};